var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcAnatraWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.92 18.9099L34.72 20.1399",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.12 44.29C32.8 33.08 19.24 30.77 19.76 25.53C20.06 22.49 24.84 23.16 24.84 23.16C26.03 21.88 28.97 19.98 29.06 17.42C29.15 14.86 32.85 15.14 32.24 13.34C35.04 15.57 39.98 20.74 43.98 22.82C47.98 24.9 47.8 27.27 44.23 28.15C36.7 30.01 33.27 25.04 29.73 24.82C27.11 24.65 24.84 23.15 24.84 23.15",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.23 13.35C31.39 11.85 30.34 7.53995 25.8 6.37995C20.1 4.91995 14.66 5.27995 7.55001 13.35C-0.159989 22.1 3.82001 28.8899 6.76001 35.0599",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAnatraWhite);
export default __webpack_public_path__ + "static/media/ic_anatra_white.7938663abf372941e6ad42a99373bb7e.svg";
export { ForwardRef as ReactComponent };